import { ChangeDetectionStrategy, Component, OnInit, computed, input } from "@angular/core";
import { MatProgressBar } from "@angular/material/progress-bar";
import { TzDatePipe } from "../../interactives/pipes/tz-date.pipe";

@Component({
    selector: "app-date-range-bar",
    templateUrl: "./date-range-bar.component.html",
    styleUrl: "./date-range-bar.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatProgressBar, TzDatePipe]
})
export class DateRangeBarComponent implements OnInit {
    startDate = input.required<Date>();
    endDate = input<Date | null>(null);
    /** When true, the progress indicator renders grey instead of colored. */
    colorDisabled = input<boolean>(false);
    timezone = input<string>("America/New_York");

    ngOnInit(): void {
        if (!Intl.supportedValuesOf("timeZone").includes(this.timezone())) {
            throw new Error(`DateRangeBarComponent: invalid timezone "${this.timezone()}"`);
        }
    }

    protected value = computed(() => {
        const end = this.endDate();
        if (end === null) return Date.now() >= this.startDate().getTime() ? 100 : 0;

        const progress =
            ((Date.now() - this.startDate().getTime()) / (end.getTime() - this.startDate().getTime())) * 100;
        return Math.min(100, Math.max(0, progress));
    });
}
